module.exports = __webpack_public_path__ + "img/tab6.7a6aa8c6.png";